import { Box, Grid, TextField, Button } from "@mui/material"
import {
  Body,
} from "../../screens/Login/Login.styles"
export default function PasswordlessAuth({email, handlePwdLessChange, errorsEmail, userPwdLessLoginMutation}) {

    return(
        <Box sx={{minHeight: `calc(100vh - 320px)`}}>
            <Body sx={{fontSize: '16px', fontWeight: 700, color: "#111", lineHeight: '24px',}}>
                Sign in with your email. We'll send you a temporary password to access your account.
            </Body>
            <Box>
            <Grid sx={{ marginBottom: '20px',}}>
                    <TextField
                        label={!email ? "Email address" : undefined}
                        value={email}
                        name="email"
                        onChange={handlePwdLessChange}
                        fullWidth
                        required
                        error={!!errorsEmail}
                        helperText={errorsEmail}
                        InputProps={{
                            sx: {
                            backgroundColor: 'white'
                            }
                        }}
                    />
            </Grid>
                <Grid sx={{ marginBottom: '20px', }}>
                <Button
                    type="submit"
                    variant="contained"
                    sx={{
                        textTransform: 'none',
                        width: '100%'
                    }}
                    disabled={userPwdLessLoginMutation.isPending}
                >
                    {userPwdLessLoginMutation.isPending? "Loading..." : "Generate Password"}
                </Button>
                </Grid>
            </Box>
        </Box>
    );
}
